import { render } from "./profile-index.vue?vue&type=template&id=1bd8a05a"
import script from "./profile-index.vue?vue&type=script&lang=js"
export * from "./profile-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__